import { getSafeUrl } from 'pubweb-react-components/dist/utils/urlUtility';
import { getGAClientId, getKenshooId } from '../utils/analytics'
import { LEAD_API_ENDPOINT } from '../utils/constants';
import getSettings from './settingService';
import { getUTMParametersFromSessionCache } from "pubweb-smokey/dist/utils/utils";
import "isomorphic-fetch";
import promise from 'es6-promise';
import { post } from '../utils/ajax';
promise.polyfill();

export const submitForm = formObj => {
    return getSettings()
        .then(settings => {
            const webUrl = getSafeUrl();
            const utmParams = getUTMParametersFromSessionCache();
            const gaClientId = getGAClientId();
            const kenshooId = getKenshooId();
            const formModel = {
                emailAddress: formObj.email ? formObj.email.trim() : undefined,
                firstName: formObj.firstName ? formObj.firstName.trim() : undefined,
                lastName: formObj.lastName ? formObj.lastName.trim() : undefined,
                zip: formObj.zip ? formObj.zip.trim() : undefined,
                phoneNumber: formObj.phone ? formObj.phone.trim() : undefined,
                canEmail: formObj.canEmail,
                dataExtension: formObj.dataExtension,
                doNotCall: formObj.doNotCall,
                originWebURL: webUrl,
                originWebApp: formObj.originWebApp,
                originWebPageType: formObj.originWebPageType,
                originWebFormType: formObj.originWebFormType,
                originWebFormCategory: formObj.originWebFormCategory,
                originCampaign: formObj.originCampaign,
                UtmCampaign: utmParams.utm_campaign,
                UtmSource: utmParams.utm_source,
                utmMedium: utmParams.utm_medium,
                utmTerm: utmParams.utm_term,
                utmContent: utmParams.utm_content,
                utmAdgroup: utmParams.utm_adgroup,
                utmMessaging: utmParams.utm_messaging,
                gaClientId: gaClientId,
                kenshooId: kenshooId
            }; 
            return post(`${settings.webServiceUrl}/api/${LEAD_API_ENDPOINT}`, formModel);
        })
};

export default submitForm;